let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5Yxt8")).then(() => parcelRequire('4e6Iv'));